export const getVideoSettingsEditorStyles = () => ({
  videoSettingsEditor: {
    '& .plus-button-container': {
      marginTop: 16,
      '& .item-title span': {
        fontWeight: 600,
      },
      '& .add-image-button': {
        marginTop: 8,
        width: 'auto',
        height: 'auto',
        '& span': {
          width: 106,
          border: '1px dashed #c8c6c4',
          height: 76,
          borderRadius: 6,
        },
      },
    },
  },
});
